import {Component} from 'react';
import Security from "./security";

class ScreenComponent extends Component {
    constructor(props) {
        super(props);

        this._isMounted = false;

        const [canAccess, redirect] = Security.canAccess(props.location.pathname);

        if (!canAccess) {
            props.history.push(redirect);
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setState(state, callback) {
        this._isMounted && super.setState(state, callback);
    }
}

export default ScreenComponent;